import { defineComponent } from 'vue'
import './Loading.less'

export default defineComponent({
  setup(props, ctx) {
    return () => (
      <div id="main-loading">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    )
  }
})